import { render } from "./Abertura_Embalagem.vue?vue&type=template&id=5e6c7283&scoped=true"
import script from "./Abertura_Embalagem.vue?vue&type=script&lang=js"
export * from "./Abertura_Embalagem.vue?vue&type=script&lang=js"

import "./Abertura_Embalagem.vue?vue&type=style&index=0&id=5e6c7283&lang=css"
import "./Abertura_Embalagem.vue?vue&type=style&index=1&id=5e6c7283&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e6c7283"]])

export default __exports__